// extracted by mini-css-extract-plugin
export default {"text":"SkippedPaymentDialog__text--15-DN"};